import React from 'react';
import Hero from '../components/Hero';
import About from '../components/About';
import Services from '../components/Services';
import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import SocialMedia from '../components/SocialMedia';
import Gallery from '../components/Gallery';

const HomePage = () => {
  return (
    <main>
      <Hero />
      <About />
      <Services />
      <Testimonials />
      <FAQ />
      <SocialMedia />
      <Gallery />
    </main>
  );
};

export default HomePage;
